import useApiRequest from 'api/useApiRequest';
import { fetchTeamLobbyingMaterial, type TeamLobbyingMaterialItem } from 'api/services/lobbyingMaterialService';

const useLobbyingMaterial = () => {
  const { request } = useApiRequest();

  const getTeamLobbyingMaterial = async ({
    signal,
  }: { signal?: AbortSignal } = {}): Promise<TeamLobbyingMaterialItem[]> => {
    const { data } = await fetchTeamLobbyingMaterial(request, { signal });
    const { myUserGeneratedContent = [], teamMemberUserGeneratedContent = [] } = data ?? {};
    return [...myUserGeneratedContent, ...teamMemberUserGeneratedContent].sort(
      (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
    );
  };

  return { getTeamLobbyingMaterial };
};

export default useLobbyingMaterial;
